/**
 * ShopTile.jsx — Ceramic Pieces Promo Tile
 *
 * Props:
 *   onOpenShop {Function} — called when the user clicks "View Collection"
 */
import { useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { useShopContent } from '../services/firestore';

export default function ShopTile({ onOpenShop }) {
  const { shop } = useShopContent();
  const { tile } = shop;

  // Pre-warm getShopProducts so the shop page loads instantly when opened.
  useEffect(() => {
    httpsCallable(
      functions,
      'getShopProducts',
    )({ warmup: true }).catch(() => {});
  }, []);

  return (
    <div className="section-pad">
      <div
        className="tile two-col-tile"
        style={{ backgroundColor: '#e8a020', border: 'none' }}
      >
        {/* ── Left — heading and teaser copy ──────────────────────────── */}
        <div>
          <p
            style={{
              fontFamily: "'Raleway', sans-serif",
              fontWeight: 700,
              fontSize: '0.7rem',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: '#1a1208',
              marginBottom: 12,
            }}
          >
            {tile.label}
          </p>
          <h3
            style={{
              fontFamily: "'Titan One', sans-serif",
              fontWeight: 400,
              fontSize: '1.8rem',
              lineHeight: 1.1,
              color: '#1a1208',
              textTransform: 'uppercase',
              letterSpacing: '-0.01em',
              marginBottom: 12,
            }}
          >
            {tile.heading}
          </h3>
          <p
            style={{
              fontFamily: "'Raleway', sans-serif",
              fontWeight: 700,
              fontSize: 'clamp(1rem, 1.8vw, 1.1rem)',
              color: '#1a1208',
              lineHeight: 1.6,
            }}
          >
            {tile.description}
          </p>
        </div>

        {/* ── Right — teaser item list + CTA button ────────────────────── */}
        <div>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: '0 0 28px',
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            {tile.teaserItems.map((item) => (
              <li
                key={item}
                style={{
                  fontFamily: "'Raleway', sans-serif",
                  fontWeight: 700,
                  fontSize: '0.9rem',
                  color: '#1a1208',
                  paddingLeft: 16,
                  borderLeft: '2px solid #1a120855',
                }}
              >
                {item}
              </li>
            ))}
          </ul>
          <button className="thin-btn shop-btn" onClick={onOpenShop}>
            {tile.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}
